<template>
  <div class="contents-inner">
    <template v-if="!isLightPlan">
      <p
        v-if="companyInfo.catchCopy"
        class="fwB"
        data-test="catch"
      >
        {{ companyInfo.catchCopy }}
      </p>
      <p
        class="taC mt15"
        data-test="introImage"
      >
        <img
          v-if="companyInfo.introImage && companyInfo.introImage.id"
          class="company-img-main image-height-auto"
          :src="getPhotoUrl(companyInfo.introImage)"
        >
      </p>
      <p
        v-if="companyInfo.introText"
        class="mt15 pega-pre-wrap"
        data-test="introText"
        v-text="companyInfo.introText"
      />
    </template>

    <p
      class="hd-type-0n3"
      data-test="name-title"
    >
      <span>会社名</span>
    </p>
    <p
      v-if="companyInfo.name"
      class="mt20"
      data-test="name"
    >
      {{ companyInfo.name }}
    </p>

    <p
      class="hd-type-0n3"
      data-test="businessContent-title"
    >
      <span>事業内容</span>
    </p>
    <p
      v-if="companyInfo.businessContent"
      class="mt20 pega-pre-wrap"
      data-test="businessContent"
      v-text="companyInfo.businessContent"
    />

    <template v-if="companyInfo.established">
      <p
        class="hd-type-0n3"
        data-test="established-title"
      >
        <span>設立</span>
      </p>
      <p
        class="mt20"
        data-test="established"
      >
        {{ companyInfo.established }}
      </p>
    </template>

    <template v-if="companyInfo.capital">
      <p
        class="hd-type-0n3"
        data-test="capital-title"
      >
        <span>資本金</span>
      </p>
      <p
        class="mt20"
        data-test="capital"
      >
        {{ companyInfo.capital }}
      </p>
    </template>

    <template v-if="companyInfo.sale">
      <p
        class="hd-type-0n3"
        data-test="sale-title"
      >
        <span>売上高</span>
      </p>
      <p
        class="mt20"
        data-test="sale"
      >
        {{ companyInfo.sale }}
      </p>
    </template>

    <template v-if="isShow.employee">
      <p
        class="hd-type-0n3"
        data-test="employeeNumber-title"
      >
        <span>従業員数</span>
      </p>
      <p
        v-if="companyInfo.employeeNumber"
        class="mt20"
        data-test="employeeNumber"
      >
        {{ companyInfo.employeeNumber }}
      </p>
      <dl
        v-if="companyInfo.averageAge"
        class="bg-blue-box mt15"
        data-test="averageAge"
      >
        <dt>平均年齢</dt>
        <dd>{{ companyInfo.averageAge }}</dd>
      </dl>
      <dl
        v-if="companyInfo.midCareerPercentage"
        class="bg-blue-box mt10"
        data-test="midCareerPercentage"
      >
        <dt>中途入社の割合</dt>
        <dd>{{ companyInfo.midCareerPercentage }}</dd>
      </dl>
    </template>

    <template v-if="isShow.representative">
      <p
        class="hd-type-0n3"
        data-test="representative-title"
      >
        <span>代表者</span>
      </p>
      <p
        v-if="companyInfo.representative"
        class="mt20"
        data-test="representative"
      >
        {{ companyInfo.representative }}
      </p>
      <dl
        v-if="companyInfo.representativeProfile"
        class="bg-blue-box mt15"
        data-test="representativeProfile"
      >
        <dt>代表者略歴</dt>
        <dd
          class="pega-pre-wrap"
          v-text="companyInfo.representativeProfile"
        />
      </dl>
    </template>

    <template v-if="companyInfo.note">
      <p
        class="hd-type-0n3"
        data-test="note-title"
      >
        <span>備考</span>
      </p>
      <p
        class="mt20 pega-pre-wrap"
        data-test="note"
        v-text="companyInfo.note"
      />
    </template>

    <template v-if="companyInfo.hp">
      <p
        class="hd-type-0n3"
        data-test="hp-title"
      >
        <span>企業HP</span>
      </p>
      <p
        class="mt20"
        data-test="hp"
      >
        <a
          :href="companyInfo.hp"
          target="_blank"
          rel="nofollow"
        >{{ companyInfo.hp }}</a>
      </p>
    </template>

    <template v-if="!isLightPlan">
      <template v-for="index in [1,2,3]">
        <div
          v-if="companyInfo[`companyImage${index}Caption`]"
          :key="index"
          class="remarks-block"
          :class="[{'mt20':index===1},{'mt10':index!==1}]"
          :style="`background: url(${userCommonImageUrlForSp}/bg_stripe_gray.png) repeat top left;`"
          :data-test="`companyImage-${index}`"
        >
          <img
            v-if="companyInfo[`companyImage${index}`].id"
            :src="getPhotoUrl(companyInfo[`companyImage${index}`])"
            class="company-img-sub image-height-auto"
            :data-test="`image-${index}`"
          >
          <p>{{ companyInfo[`companyImage${index}Caption`] }}</p>
        </div>
      </template>
    </template>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  mixins: [jobPreviewCommon],
  props: {
    isLightPlan: {
      type: Boolean,
      default: false
    },
    companyInfo: {
      type: Object,
      required: true
    }
  }
}
</script>
